import { BookingDTO } from '../dtoTypes'
import { Booking } from '../types'
import { adaptAdBookingInfoDTO } from 'entities/areas/model/adapters/adaptAdBookingInfoDTO'

export const adaptBookingDTO = (bookingDTO: BookingDTO): Booking => ({
    id: bookingDTO.id,
    comment: bookingDTO.comment,
    endTime: new Date(bookingDTO.end_time),
    startTime: new Date(bookingDTO.start_time),
    areaPrice: bookingDTO.area_price,
    areaPercentDiscount: bookingDTO.area_percent_discount,
    areaAbsolutDiscount: bookingDTO.area_absolut_discount,
    nomenclaturesPrice: bookingDTO.nomenclatures_price,
    nomenclaturePriceWithDiscount: bookingDTO.nomenclature_price_with_discount,
    orderId: bookingDTO.order_id,
    area: {
        id: bookingDTO?.area?.id ?? null,
        name: bookingDTO?.area?.name ?? null,
        adBookingInfo: bookingDTO?.area?.ad_booking_info
            ? adaptAdBookingInfoDTO(bookingDTO.area.ad_booking_info)
            : null,
    },
    counterparty: {
        id: bookingDTO.counterparty.id,
        fullName: bookingDTO.counterparty.full_name,
        phone: bookingDTO.counterparty.phone,
        type: bookingDTO.counterparty.type,
    },
    paidStatus: bookingDTO.paid_status,
    createdAt: new Date(bookingDTO.created_at),
    expireTime: bookingDTO.expire_time
        ? new Date(bookingDTO.expire_time)
        : null,
})
